<div style="padding-top: 20px; padding-bottom: 20px;">
  <i class="fas fa-check-circle fa-10x d-flex justify-content-center" style="color: green;"></i>
  <div style="padding-top: 40px; font-size: 20px;" class="d-flex justify-content-center">Thank you for filing an Application with Resolution Institute.</div>
  <br />
  <p>You will be emailed a PDF copy of the application form along with your matter reference number.</p>
  <p>We will be in contact with you again shortly to outline the important next steps in progressing your complaint.</p>
  <p><b>Payment of the administration fee</b></p>

  <p>Please follow the link below to visit the online to store to make payment of the Application Fee: </p>
  <p><a href="https://resolution.institute/Web/Shop/Domain_Name_Disputes  " target="_blank">https://resolution.institute/Web/Shop/Domain_Name_Disputes</a></p>
  <p>Should you have any further questions, please contact Nomination Services via email on nominations@resolution.institute</p>
</div>
